import { AxiosResponse } from "axios";
import axiosInstance from "../core/axios";
import { SettingsDetailsType } from "../types/genericType";
import { apiEndPoints } from "../variables/apiEndpoints";

export const getSettingsDetails = async (): Promise<SettingsDetailsType> => {
  try {
    const response: AxiosResponse<SettingsDetailsType> =
      await axiosInstance.get(`${apiEndPoints.settings}`);
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const updateSettingsDetails = async (
  field: string,
  value: string
): Promise<SettingsDetailsType> => {
  try {
    const response: AxiosResponse<SettingsDetailsType> =
      await axiosInstance.put(`${apiEndPoints.settings}`, {
        key: field,
        value: value,
      });
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const getWelcomeBanner = async (): Promise<{ WelcomeBanner: string }> => {
  try {
    const response: AxiosResponse<{ WelcomeBanner: string }> =
      await axiosInstance.get(apiEndPoints.welcomeBanner);
    return response?.data;
  } catch (err) {
    throw err;
  }
};